import { useEffect } from 'react';

import { useChatStoreShallow } from '@refly/stores';
import { useListProviderItems } from '@refly-packages/ai-workspace-common/queries';
import { useUserStoreShallow } from '@refly/stores';

export const useGetMediaModel = () => {
  const { setMediaModelList, setMediaModelListLoading } = useChatStoreShallow((state) => ({
    setMediaModelList: state.setMediaModelList,
    setMediaModelListLoading: state.setMediaModelListLoading,
  }));
  const { isLogin } = useUserStoreShallow((state) => ({
    isLogin: state.isLogin,
  }));
  const { data, isLoading } = useListProviderItems(
    {
      query: {
        // 与对话模型一致：不按已废弃的 providerMode 过滤，内置与用户自有模型一并返回。
        category: 'mediaGeneration',
        enabled: true,
      },
    },
    null,
    {
      enabled: isLogin,
    },
  );

  useEffect(() => {
    if (data?.data) {
      setMediaModelList(data.data);
    }
  }, [data?.data, setMediaModelList]);

  useEffect(() => {
    setMediaModelListLoading(isLoading);
  }, [isLoading, setMediaModelListLoading]);
};
